import request from '@/util/request';

//充电站列表
export const getStationList = (params, options) =>
  request.get(
    '/api/v4ward/charger/station/chargerStationList/v2',
    Object.assign({}, options, {
      params
    })
  );

//收款商户
export const getMerchantList = (params, options) =>
  request.get(
    '/api/v4ward/charger/refill/rule/getPayMerchantList/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取小区列表
export const getAreaNameList = (params, options) =>
  request.get(
    '/api/v4ward/charger/area/getAreaName/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取代理商列表
export const getChargerAgentList = (params, options) =>
  request.get(
    '/api/v4ward/charger/agent/getChargerAgentList/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取充电桩
export const getPileList = (params, options) =>
  request.get(
    '/api/v4ward/charger/device/chargerDeviceList/v2',
    Object.assign({}, options, {
      params
    })
  );
